function Step2DefaultHomepageContent({
 templateState,
 setTemplateField,

 coverFile,
 setCoverFile,
 existingCoverUrl,
 removeCover,
 setRemoveCover,
}) {
 return (
  <div className="card">
   <h2>Homepage content</h2>
   <label className="field">
    <span>Homepage title</span>
    <input
     value={templateState.title || ""}
     onChange={(e) => setTemplateField("title", e.target.value)}
     placeholder="DMR Tennis"
    />
   </label>
   <label className="field">
    <span>Short headline</span>
    <input
     value={templateState.headline || ""}
     onChange={(e) => setTemplateField("headline", e.target.value)}
     placeholder="Adult basketball league in Orange County"
    />
   </label>

   <div className="row-2">
    <label className="field">
     <span>Sport</span>
     <input
      value={templateState.meta_sport || ""}
      onChange={(e) => setTemplateField("meta_sport", e.target.value)}
      placeholder="Basketball"
     />
    </label>

    <label className="field">
     <span>Location</span>
     <input
      value={templateState.meta_location || ""}
      onChange={(e) => setTemplateField("meta_location", e.target.value)}
      placeholder="Orange County, CA"
     />
    </label>
   </div>

   <div className="field">
    <span>Cover image</span>

    {existingCoverUrl && !coverFile && !removeCover ? (
     <div className="existing-file-row">
      <span className="existing-file-pill">
       Current cover uploaded
      </span>

      <a
       href={existingCoverUrl}
       target="_blank"
       rel="noreferrer"
       className="existing-file-link"
      >
       View
      </a>

      <button
       type="button"
       className="existing-file-remove"
       onClick={() => {
        setRemoveCover(true);
        setCoverFile(null);
       }}
      >
       Remove
      </button>
     </div>
    ) : null}

    {removeCover ? (
     <div className="existing-file-row">
      <span className="existing-file-pill">
       Cover will be removed
      </span>

      <button
       type="button"
       className="existing-file-link"
       onClick={() => setRemoveCover(false)}
      >
       Undo
      </button>
     </div>
    ) : null}

    <div className="file-row">
     <input
      id="cover-upload"
      type="file"
      accept="image/*"
      className="file-hidden"
      onChange={(e) => {
       const file = e.target.files?.[0] || null;

       setCoverFile(file);

       if (file) {
        setRemoveCover(false);
       }
      }}
     />

     <label htmlFor="cover-upload" className="file-btn">
      Choose File
     </label>

     <div className="file-name">
      {coverFile?.name || "No file chosen"}
     </div>
    </div>
   </div>

   <div className="row-2">
    <label className="field">
     <span>Hero button text</span>
     <input
      value={templateState.registration_label || ""}
      onChange={(e) =>
       setTemplateField("registration_label", e.target.value)
      }
      placeholder="Register"
      maxLength={30}
     />
    </label>

    <label className="field">
     <span>Hero button link</span>
     <input
      value={templateState.registration_url || ""}
      onChange={(e) =>
       setTemplateField("registration_url", e.target.value)
      }
      placeholder="https://..."
     />
    </label>
   </div>
  </div>
 );
}

export default Step2DefaultHomepageContent;